import { combineReducers } from 'redux';

import roles from './roles';
import rights from './rights';
import options from './options';

export default combineReducers({ roles, rights, options });
